const translations = {
  en: {
    app_name: "THE FIRE WITHIN",
    login: "Login",
    chapter: "CHAPTER",
    chapters: "Chapters",
    audioBook: "Audio Book",
    register_now: "Register Now",
    discover: "Discover a world of digital content",
    name: "Name",
    enter_name: "Enter Name",
    email: "Email",
    enter_email: "Enter Email",
    password: "Password",
    enter_password: "Enter Password",
    register: "Register",
    forgot_password: "Forgot Password?",
    already_account: "Already have an account ? ",
    click_here_to_login: "Click here to login",
    forgot_password_title: "Forgot Password.",
    verify: "Verify",
    back_to_register: "Back to register",
    please_login: "Please enter your detail to login",
    dont_have_account: "Don’t have an account?",
    Click_here_to_register: "Click here to register",
    privacy_policy: "Privacy Policy",
    terms_service: "Term of Service",
    accessibility: "Accessibility Statement",
    cookie_policy: "Cookie Policy",
    rights_reserved: "@ 2025  Indel Service, LLC. All Rights Reserved.",
    listen: "Listen",
    read: "Read",
    podcast: "Podcast",
    profile: "Profile",
    back_to_dashboard: "Back to dashboard",
    listen_upper: "LISTEN",
    read_upper: "READ",
    podcast_upper: "PODCAST",
    contents: "Contents",
    select_language: "Select Language",
    my_account: "My Account",
    logout: "Logout",
    logging_in: "Logging in...",
    fire_within: "Fire Within",
    back_to_website: "Back to website",
    registering: "Registering...",
    please: "Please",
    enter_your: "enter your",
    details_to: "details to",
    verifying: "Verifying…",
    loading: "Loading…",
    updating: "Updating…",
    update: "UPDATE",
    old_password: "Old Password",
    enter_old_password: "Enter Old Password",
    new_password: "New Password",
    verify_password: "Verify New Password",
    welcome: "Welcome",
    change_password: "Change Password",
    thank_you_for_registering: "Thank you for registering!",
    email_for_login_credentials:
      "Please check your registered email for login credentials.",
    back_to: "Back to",
    set_your_new_password: "Set Your New Password",
    password_must_include_a_special_character:
      "Password must include a special character (!@#$%^&*)",
    password_must_include_a_number: "Password must include a number",
    password_must_include_an_uppercase_letter:
      "Password must include an uppercase letter",
    Password_character: "Password must be at least 8 character",
    new_password_is_required: "New password is required",

    // Description content
    title: "THE FIRE WITHIN",
    description: `is an autobiography by industrialist Henry M. Rowan, chronicling his remarkable journey
      from a young engineer to the founder of Inductotherm Industries, Inc. The book traces his
      life from small-town America through World War II flight school and into his entrepreneurial
      endeavors. In 1953, Rowan started Inductotherm at his kitchen table, selling his house and
      risking everything to pursue his vision. His record-breaking $100 million gift to a small
      New Jersey college in 1992 brought him international attention, but it was just one chapter
      in a lifetime of bold decisions and personal resilience. The Fire Within is not only a tale
      of innovation and grit but also a quintessential American success story.`,
  },

  ko: {
    app_name: "내면의 불꽃",
    login: "로그인",
    chapter: "챕터",
    chapters: "챕터 목록",
    audioBook: "오디오북",
    register_now: "신규 가입하기",
    discover: "디지털 콘텐츠의 세계를 발견하십시오.",
    name: "이름",
    enter_name: "이름 입력",
    email: "이메일",
    enter_email: "이메일 입력",
    password: "비밀번호",
    enter_password: "비밀번호 입력",
    register: "가입하기",
    forgot_password: "비밀번호를 잊으셨나요?",
    already_account: "이미 계정이 있으신가요?",
    click_here_to_login: " 여기를 클릭하여 로그인하세요.",
    forgot_password_title: "비밀번호 찾기",
    verify: "인증",
    back_to_register: "가입으로 돌아가기",
    please_login: "로그인을 위해 정보를 입력하세요",
    dont_have_account: "계정이 없으신가요?",
    Click_here_to_register: "가입하려면 여기를 클릭하세요",
    privacy_policy: "개인정보 처리방침",
    terms_service: "이용약관",
    accessibility: "접근성",
    cookie_policy: "쿠키 정책",
    rights_reserved: "@ 2025 INDEL Service, LLC. 모든 권리 보유.",
    listen: "듣기",
    read: "읽기",
    podcast: "팟캐스트",
    profile: "프로필",
    back_to_dashboard: "대시보드로 돌아가기",
    listen_upper: "듣기",
    read_upper: "읽기",
    podcast_upper: "팟캐스트",
    select_language: "언어 선택",
    my_account: "내 계정",
    logout: "로그아웃",
    logging_in: "로그인 중...",
    fire_within: "내면의 불꽃",
    back_to_website: "웹사이트로 돌아가기",
    registering: "등록 중…",
    please: "입력해 주세요",
    enter_your: "당신의",
    details_to: "자세한 내용",
    verifying: "확인 중…",
    contents: "목차",
    loading: "로드 중…",
    updating: "업데이트 중…",
    update: "업데이트",
    old_password: "이전 비밀번호",
    enter_old_password: "이전 비밀번호를 입력하세요",
    new_password: "새 비밀번호",
    verify_password: "새 비밀번호 확인",
    welcome: "환영",
    change_password: "비밀번호 변경",
    thank_you_for_registering: "등록해주셔서 감사합니다!",
    email_for_login_credentials:
      "로그인 자격 증명을 위해 등록된 이메일을 확인하세요.",
    back_to: "돌아가기",
    set_your_new_password: "새 비밀번호 설정",
    password_must_include_a_special_character:
      "비밀번호에는 특수문자(!@#$%^&*)가 포함되어야 합니다.",
    password_must_include_a_number: "비밀번호에는 숫자가 포함되어야 합니다",
    password_must_include_an_uppercase_letter:
      "비밀번호에는 대문자가 포함되어야 합니다.",
    Password_character: "비밀번호는 최소 8자 이상이어야 합니다.",
    new_password_is_required: "새 비밀번호가 필요합니다",

    // Description content
    title: "더 파이어 위딘",
    description: `산업가 헨리 M. 로완의 자서전으로, 젊은 엔지니어에서 인덕토썸 인더스트리의
      창립자가 되기까지의 놀라운 여정을 담고 있습니다. 이 책은 그가 작은 미국 마을에서
      제2차 세계대전 비행학교를 거쳐 기업가로 성장한 과정을 보여줍니다.
      1953년 로완은 자신의 주방 테이블에서 인덕토썸을 시작하며, 집을 팔고 모든 것을 걸었습니다.
      그의 비전은 위험했지만 결단력으로 이어졌습니다. 1992년 뉴저지의 한 작은 대학에
      1억 달러를 기부한 일은 국제적인 주목을 받았지만, 그것은 그의 평생에 걸친
      대담한 결정과 인내심 중 한 장면에 불과했습니다. ‘더 파이어 위딘’은 혁신과 용기의 이야기이자,
      미국식 성공의 진정한 본보기입니다.`,
  },

  tw: {
    app_name: "心中之火",
    login: "登入",
    chapter: "章",
    chapters: "章節",
    audioBook: "有聲書",
    register_now: "立即註冊",
    discover: "發現",
    name: "姓名",
    enter_name: "輸入姓名",
    email: "電子郵件",
    enter_email: "輸入電子郵件",
    password: "密碼",
    enter_password: "輸入密碼",
    register: "註冊",
    forgot_password: "忘記密碼？",
    already_account: "已經有帳號了嗎？",
    click_here_to_login: "點此登入",
    forgot_password_title: "忘記密碼標題",
    verify: "核實",
    back_to_register: "回註冊",
    please_login: "請登入",
    dont_have_account: "還沒有帳號？",
    Click_here_to_register: "點此註冊",
    privacy_policy: "隱私權政策",
    terms_service: "服務條款",
    accessibility: "無障礙聲明",
    cookie_policy: "Cookie 政策",
    rights_reserved: "© 2025 Indel Service, LLC. 版權所有。",
    listen: "聆聽",
    read: "讀",
    podcast: "podcast",
    profile: "輪廓",
    back_to_dashboard: "返回主控台",
    listen_upper: "聆聽",
    read_upper: "閱讀",
    podcast_upper: "播客",
    select_language: "選擇語言",
    my_account: "我的帳戶",
    logout: "登出",
    logging_in: "登入中…",
    fire_within: "心中之火",
    back_to_website: "返回網站",
    registering: "註冊中…",
    please: "請輸入",
    enter_your: "您的",
    details_to: "詳細資料",
    verifying: "驗證中…",
    contents: "目錄",
    loading: "載入中…",
    updating: "更新中…",
    update: "更新",
    old_password: "舊密碼",
    enter_old_password: "輸入舊密碼",
    new_password: "新密碼",
    verify_password: "確認新密碼",
    welcome: "歡迎",
    change_password: "變更密碼",
    thank_you_for_registering: "感謝您的註冊！",
    email_for_login_credentials: "登入憑證的電子郵件",
    back_to: "返回",
    set_your_new_password: "設定您的新密碼",
    password_must_include_a_special_character:
      "密碼必須包含特殊字符 (!@#$%^&*)",
    password_must_include_a_number: "密碼必須包含數字",
    password_must_include_an_uppercase_letter: "密碼必須包含大寫字母",
    Password_character: "密碼至少需要 8 個字元",
    new_password_is_required: "需要新密碼",

    // Description content
    title: "內心之火",
    description: `《心中之火》是實業家亨利·M·羅恩（Henry M. Rowan）的自傳，記載了他從一名年輕工程師，
  成長為應達工業集團（Inductotherm Industries, Inc.）創辦人的非凡歷程。
  本書回顧了他從小鎮生活、經歷二戰飛行學校，直至投身創業的人生軌跡。
  1953 年，羅恩在自家的廚房餐桌上創立了 Inductotherm，
  他賣掉房子、孤注一擲追求自己的願景。
  1992 年，他向紐澤西州一所小型學院捐贈了一億美元，創下紀錄並引發國際關注，
  但這只是他一生中眾多大膽抉擇與堅韌精神的一個篇章。
  《心中之火》不僅是一個關於創新與毅力的故事，
  更是一個典型的美國成功傳奇。`,
  },

  jpn: {
    app_name: "『内なる炎』",
    login: "ログイン",
    chapter: "章",
    chapters: "章",
    audioBook: "オーディオブック",
    register_now: "新規登録",
    discover: "デジタルコンテンツの世界を探索しよう",
    name: "氏名",
    enter_name: "氏名を入力",
    email: "メールアドレス",
    enter_email: "メールアドレスを入力",
    password: "パスワード",
    enter_password: "パスワードを入力",
    register: "登録する",
    forgot_password: "パスワードをお忘れですか？",
    already_account: "すでにアカウントをお持ちですか？ ",
    click_here_to_login: "アカウントをお持ちの方はログイン",
    forgot_password_title: "パスワードの再設定",
    verify: "認証する",
    back_to_register: "登録画面に戻る",
    please_login: "ログイン情報を入力してください",
    dont_have_account: "アカウントをお持ちではありませんか？",
    Click_here_to_register: "ここをクリックして登録",
    privacy_policy: "プライバシーポリシー",
    terms_service: "利用規約",
    accessibility: "アクセシビリティ方針",
    cookie_policy: "クッキーポリシー",
    rights_reserved: "© 2025 Indel Service, LLC. 無断転載を禁じます。",
    listen: "聴く",
    read: "読む",
    podcast: "ポッドキャスト",
    profile: "プロフィール",
    back_to_dashboard: "ダッシュボードに戻る",
    listen_upper: "聴く",
    read_upper: "読む",
    podcast_upper: "ポッドキャスト",
    contents: "目次",
    select_language: "言語を選択",
    my_account: "マイアカウント",
    logout: "ログアウト",
    logging_in: "ログイン中…",
    fire_within: "内なる炎",
    back_to_website: "ウェブサイトへ戻る",
    registering: "登録中…",
    please: "どうぞ",
    enter_your: "あなたの",
    details_to: "詳細を入力してください",
    verifying: "確認中…",
    loading: "読み込み中…",
    updating: "更新中…",
    update: "更新",
    old_password: "旧パスワード",
    enter_old_password: "旧パスワードを入力",
    new_password: "新しいパスワード",
    verify_password: "新しいパスワードを確認",
    welcome: "ようこそ",
    change_password: "パスワード変更",
    thank_you_for_registering: "ご登録ありがとうございます！",
    email_for_login_credentials: "ログイン情報は登録メールをご確認ください。",
    back_to: "戻る",
    set_your_new_password: "新しいパスワードを設定",
    password_must_include_a_special_character:
      "パスワードには特殊文字（!@#$%^&*）を含める必要があります",
    password_must_include_a_number: "パスワードには数字を含める必要があります",
    password_must_include_an_uppercase_letter:
      "パスワードには大文字を含める必要があります",
    Password_character: "パスワードは8文字以上である必要があります",
    new_password_is_required: "新しいパスワードは必須です",

    // Description content
    title: "内なる炎",
    description: `『内なる炎 (The Fire Within)』は、実業家ヘンリー・M・ローワンの自叙伝であり、若きエンジニアからインダクトサーム社 
    (Inductotherm Industries, Inc.) の創業者となるまでの非凡な道のりを綴った物語です。本書は、アメリカの小さな町で過ごした日々、
    第二次世界大戦中の飛行学校時代、そして起業への挑戦を描いています。1953年、ローワンは自宅の台所でインダクトサームを立ち上げ、家を売り払い、
    すべてを賭けて自らのビジョンを追求しました。1992年に彼がニュージャージー州の小さな大学へ行った記録的な1億ドルの寄付は世界的な注目を集めま
    したが、それは大胆な決断と不屈の精神に満ちた彼の人生のほんの一章に過ぎません。『内なる炎』は、革新と根性の物語であるだけでなく、典型的なアメリカン・
    サクセスストーリーでもあります。`,
  },

  br: {
    app_name: "O Fogo Interior",
    login: "Entrar",
    chapter: "CAPITULO",
    chapters: "Capítulos",
    audioBook: "Audiolivro",
    register_now: "Cadastre-se Agora",
    discover: "Descubra um mundo de conteúdo digital",
    name: "Nome",
    enter_name: "Digite seu nome",
    email: "E-mail",
    enter_email: "Digite seu e-mail",
    password: "Senha",
    enter_password: "Digite sua senha",
    register: "Cadastrar",
    forgot_password: "Esqueceu a senha?",
    already_account: "Já tem uma conta? ",
    click_here_to_login: "Clique aqui para entrar",
    forgot_password_title: "Recuperar Senha.",
    verify: "Verificar",
    back_to_register: "Voltar ao cadastro",
    please_login: "Por favor, insira seus dados para entrar",
    dont_have_account: "Não tem uma conta?",
    Click_here_to_register: "Clique aqui para cadastrar",
    privacy_policy: "Política de Privacidade",
    terms_service: "Termos de Serviço",
    accessibility: "Declaração de Acessibilidade",
    cookie_policy: "Política de Cookies",
    rights_reserved: "© 2025 Indel Service, LLC. Todos os direitos reservados.",
    listen: "Ouvir",
    read: "Ler",
    podcast: "Podcast",
    profile: "Perfil",
    back_to_dashboard: "Voltar ao painel",
    listen_upper: "OUVIR",
    read_upper: "LER",
    podcast_upper: "PODCAST",
    contents: "Índice",
    select_language: "Selecionar Idioma",
    my_account: "Minha Conta",
    logout: "Sair",
    logging_in: "Entrando...",
    fire_within: "Fogo Interior",
    back_to_website: "Voltar ao site",
    registering: "Registrando...",
    please: "Por favor",
    enter_your: "insira seu",
    details_to: "detalhes para",
    verifying: "Verificando…",
    loading: "Carregando…",
    updating: "Atualizando…",
    update: "ATUALIZAR",
    old_password: "Senha Antiga",
    enter_old_password: "Digite a Senha Antiga",
    new_password: "Nova Senha",
    verify_password: "Verificar Nova Senha",
    welcome: "Bem-vindo",
    change_password: "Alterar Senha",
    thank_you_for_registering: "Obrigado por se registrar!",
    email_for_login_credentials:
      "Verifique seu e-mail cadastrado para as credenciais de login.",
    back_to: "Voltar para",
    set_your_new_password: "Defina sua Nova Senha",
    password_must_include_a_special_character:
      "A senha deve incluir um caractere especial (!@#$%^&*)",
    password_must_include_a_number: "A senha deve incluir um número",
    password_must_include_an_uppercase_letter:
      "A senha deve incluir uma letra maiúscula",
    Password_character: "A senha deve ter pelo menos 8 caracteres",
    new_password_is_required: "A nova senha é obrigatória",

    // Description content
    title: "O FOGO INTERIOR",
    description: `O Fogo Interior' é uma autobiografia do industrial Henry M. Rowan, narrando sua notável
     jornada de jovem engenheiro a fundador da Inductotherm Industries, Inc. O livro traça sua vida desde
      uma pequena cidade americana, passando pela escola de aviação na Segunda Guerra Mundial, até seus
      empreendimentos empresariais. Em 1953, Rowan iniciou a Inductotherm na mesa de sua cozinha, vendendo
       sua casa e arriscando tudo para perseguir sua visão. Sua doação recorde de 100 milhões de dólares para
      uma pequena faculdade de Nova Jersey em 1992 atraiu atenção internacional, mas foi apenas um capítulo em
      uma vida de decisões ousadas e resiliência pessoal. 'O Fogo Interior' não é apenas um conto de inovação e garra,
       mas também uma história de sucesso tipicamente americana.`,
  },
};

export default translations;
